import styled from 'styled-components'

export const Container = styled.div`
  background-color: #FCF8EF;
  display: flex;
  padding: 80px 72px;

  @media (max-width: 911px) {
    padding-inline: 0;
  }

  @media (max-width: 912px) {
    padding-block: 40px;
  }
`

export const Content = styled.div`
  align-items: center;
  display: grid;
  gap: 40px;
  grid-template-columns: 36% 60%;
  justify-content: space-around;
  margin-inline: auto;
  max-width: 1366px;
  width: 100%;

  @media (max-width: 911px) {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 546px;
  width: 100%;

  & > h6 {
    color: #00A988;
    font-size: 1rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 16px;

    & > h1 {
      color: #084F43;
      font-size: 1.5rem;
      font-weight: 500;
    }

    & > p {
      color: #3A3847;
      font-size: 1rem;
      font-weight: 400;
    }

    & > a {
      padding: 8px 24px;
      width: fit-content;
    }
  }

  @media (max-width: 911px) {
    padding-inline: 24px;

    & > div > a {
      display: none;
    }
  }
`
